import {Editor, Transforms} from "slate";
import {deserialize} from "./serialization.ts";


const withPasteHTML = (editor: Editor) => {
    const { insertData } = editor
    editor.insertData = (data: DataTransfer) => {
        const html = data.getData('text/html')
        if (html) {
            Transforms.insertFragment(editor, deserialize(html))
            return
        }
        insertData(data)
    }

    return editor
}

export default withPasteHTML
